<script>
	import Helper from './components/Helper.svelte';
	import Permisos from './componentes/Permisos.svelte';
	
	import Input from './componentes/Forms/Input.svelte';
	import Modal from './components/Modal.svelte';
	import Titlesection from './components/Titlesection.svelte';
	import AnimationContainer from './components/AnimationContainer.svelte';
	import Navbar from './components/Navbar.svelte';
    import { push } from 'svelte-spa-router';
    import { urlapi, permisos, permisos_struct,permisos_title,miPermiso,iduser,login, sucursalStore } from './stores/store';
    import { object2array, postData, isJson, mergeDeep } from './scripts';

    export let params = {}

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if(
                $miPermiso.usuarios.access===false
                || ($miPermiso.usuarios.viewSelf===true && params.id!==$iduser)
                || ($miPermiso.usuarios.edit!==true && parseInt(params.id)!==0)
                || ($miPermiso.usuarios.insert!==true && parseInt(params.id)===0)
            ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    let sucursales=[];
    Object.keys($sucursalStore).map(function(value) { sucursales=[...sucursales,{[value] :$sucursalStore[value]}] });

    sucursales=[...sucursales,{9999:'Todas'}]

    // campos
    let id=false;
    let usuario='';
    let password='';
    let sucursal='';
    let nombre='';
    let apellidos='';
    let direccion='';
    let dpi='';
    let fechaNacimiento='0000-00-00';
    let correo='';
    let telefono='';
    let helper=false;
    let mispermisos=$permisos_struct;
    let roles='0';
    
    // status
    let disabled=false;
    let guardando=false;
    let insertando=false;
    let verificando=false;
    let usuarioVerificado=0; // 0 no verificado | 1 verificado bueno | verificado malo
    let passwordView=false;

    // variables de errores
    let campoUsuario=false;    
    let campoPassword=false;
    let error_usuario=false;
    let error_password=false;

    let rolesbd=[ {'0':'Personalizado'}]
    //let rolesbd_permisos=[ {'0':$permisos_struct} ]
    let rolesbd_permisos=[ {id:'0', permiso: $permisos_struct} ]



    function esPermiso(perm) {
        return perm.id === '5';
    }

    let function_salir = function () { push('/usuarios'); }

    let function_delete=function()
    {
        disabled=true;
        guardando=true;
        postData($urlapi, [{ 
            id,
            'cmd':'users_delete' 
        }])
        .then(data => {
            
            guardando=false;
            disabled=false;
            function_salir();
        });        
    }

    let save=async function()
    {
        const result = await verificarUser();
        if(error_usuario!==false) { return }
        
        const result2 = await verificarPassword();
        if(error_password!==false) { return }

        if(error_usuario===false && error_password===false) {
            disabled=true;
            guardando=true;

            const res = await postData($urlapi, [{ 
                id,
                usuario,
                password,
                nombre,
                apellidos,
                direccion,
                dpi,
                fechaNacimiento,
                correo,
                telefono,
                sucursal,
                insertando,
                'permisos':mispermisos,
                'rol': roles,
                'cmd':'users_save' 
            }])
            .then(data => {
                guardando=false;
                disabled=false;
                console.log(sucursal,data)
                //function_salir();
            });
        }
    }


    let load=function()
    {
        postData($urlapi, [{ 'id':id, 'cmd':'users_edit' }])
        .then(data => {
            if(data[0].result===false) {
                function_salir();
            } else {
                
                passwordView=false;
                usuario=data[0].result.user
                password=data[0].result.password
                sucursal=data[0].result.sucursal
                nombre=data[0].result.nombre
                apellidos=data[0].result.apellidos
                dpi=data[0].result.dpi
                fechaNacimiento=data[0].result.fecha_nacimiento
                correo=data[0].result.email
                telefono=data[0].result.telefono
                direccion=data[0].result.direccion
                roles=String(data[0].result.rol);
                
                if(isJson( data[0].result.permisos)===true) {
                    mispermisos=mergeDeep($permisos_struct, JSON.parse(data[0].result.permisos));
                    //mispermisos=JSON.parse(data[0].result.permisos);
                } else {
                    mispermisos=$permisos_struct;                    
                }
            }
        });   
    }

    let verificarPassword=async function() {
        
        if(password.trim()=='') {
            error_password='El password es obligatorio'
            campoPassword.focusIn();
        } else {
            error_password=false
        }
        return new Promise(resolve => { resolve('resolved'); })
    }

    let verificarUser=async function()
    {
        verificando=true;
        disabled=true;
        error_usuario=false
        usuarioVerificado=0
        
        if(usuario.trim()=='') {
            error_usuario='El usuario no puede estar vacio'
            campoUsuario.focusIn();
            usuarioVerificado=2;
            verificando=false;
            disabled=false;            
            return new Promise(resolve => { resolve('resolved'); })
        }

        const res = await postData($urlapi, [{ 'id':id,'user':usuario, 'cmd':'users_verifyUser' }])
        .then(data => {
            if(data[0].result===true)
            {
                error_usuario='El usuario ya existe'
                campoUsuario.focusIn();
                usuarioVerificado=2
            } else {
                error_usuario=false
                usuarioVerificado=1
            }
            verificando=false;
            disabled=false;
        });
        return new Promise(resolve => { resolve('resolved'); })
    }

    postData($urlapi, [{ 'cmd':'users_listPermisosID' }])
    .then(data => {
        Object.keys(data[0].result).map(function(value) { 
            rolesbd=[...rolesbd,{[data[0].result[value].id] :data[0].result[value].nombre}];
            rolesbd_permisos=[...rolesbd_permisos, {id : data[0].result[value].id , permiso: JSON.parse(data[0].result[value].permisos)} ]
        });
        if(params.id!=0)
        {
            insertando=false;
            id=params.id;
            load();
        } else {
            insertando=true;
            id=0;
        }        
    });

    let generatePassword = (
        length = 12,
        wishlist = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
    ) =>Array.from(crypto.getRandomValues(new Uint32Array(length))).map((x) => wishlist[x % wishlist.length]).join('')

    let handleKeydown=function(event) { 
        if(event.keyCode==13) save()
        if(event.keyCode==27) function_salir()
    }

</script>

<svelte:window on:keydown={handleKeydown}/>

{#if viewPage===true}

<Navbar />

<AnimationContainer marginTop=0>
    <Titlesection>
        <span slot="title"><i class="bi bi-person-fill me-1" />Usuarios
        <small class='badge bg-light text-success text-uppercase'>
        {#if insertando===true}
            Nuevo
        {:else}
            ID {id}
        {/if}
        </small>
        
        </span>
        <span slot="toolbar">

            <button {disabled} class="btn btn-success" on:click={save}  on:mouseenter={()=>helper='Guardar'} on:mouseleave={()=>helper=false}>
                {#if guardando===true}
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                {/if}
                <i class="bi bi-save"></i></button>
            <Modal classButton='btn-warning btn-sm' iconButton='bi-box-arrow-left' functionSi={function_salir} title='ADVERTENCIA' {disabled}  on:mouseenter={()=>helper='Salir'} on:mouseleave={()=>helper=false}>
                Esta seguro que desea <strong>Salir</strong>?<br/>
                Se perderán los cambios realizados
            </Modal>                
        </span>
    </Titlesection>

    <br/>
    <div class="row">
        <div class="col-12 col-md-6">

            <h6 class='fw-bold text-uppercase text-warning'>Datos de Acceso</h6>

            <div class='mb-2'>
                <div class="input-group">
                    <Input label='Usuario' bind:this={campoUsuario} bind:value={usuario} {disabled} bind:error={error_usuario} autofocus/>
                    <button {disabled}  class="btn btn-warning" type="button" on:click={verificarUser}>

                        {#if usuarioVerificado==1}
                            <i class="bi bi-check-all text-success me-1"></i>
                        {:else if usuarioVerificado==2}
                            <i class="bi bi-exclamation-circle-fill me-1 text-danger"></i>
                        {/if}                        
                        {#if verificando===true}
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {:else}
                            <i class="bi bi-search me-1"></i>
                        {/if}
                        Verificar</button>
                </div>
            </div>

            <div class="input-group mb-2">
                <Input label='Contraseña' bind:value={password} {disabled} bind:error={error_password} bind:this={campoPassword} tipo={(passwordView===true)?'text':'password'}/>

                {#if passwordView===true}
                    <button {disabled} class="btn btn-success" type="button" on:click={()=> passwordView=false}><i class="bi bi-eye"></i></button>                    
                {:else}
                    <button {disabled} class="btn btn-danger" type="button" on:click={()=> passwordView=true}><i class="bi bi-eye-slash"></i></button>
                {/if}
                
                <button {disabled}  class="btn btn-warning" type="button" on:click={()=> {password=generatePassword();passwordView=true;campoPassword.onlyFocusIn()}}><i class="bi bi-arrow-repeat me-1"></i>Generar</button>
            </div>

            <div><Input label='Sucursal' bind:value={sucursal} tipo='select' 
                datos={sucursales} 
                class='mb-2' {disabled} />
            </div>


            <h6 class='fw-bold text-uppercase text-warning mt-4'>Datos de contacto</h6>

            <div><Input label='Nombre' bind:value={nombre} class='mb-2' {disabled}/></div>
            <div><Input label='Apellidos' bind:value={apellidos} class='mb-2' {disabled}/></div>
            <div><Input label='Dirección' bind:value={direccion} class='mb-2' {disabled}/></div>
            <div><Input label='DPI' bind:value={dpi} class='mb-2' {disabled}/></div>
            <div><Input label='Fecha Nacimiento' bind:value={fechaNacimiento} tipo='date' class='mb-2' {disabled}/></div>
            <div><Input label='Correo Electrónico' bind:value={correo} tipo='email' class='mb-2' {disabled}/></div>
            <div><Input label='Teléfono' bind:value={telefono} class='mb-2' {disabled}/></div>
        
            <br/><br/>
        </div>
        <div class="col-12 col-md-6">

            <h6 class='fw-bold text-uppercase text-warning mt-4'>ROLES DE USUARIO</h6>
            <Input label='Rol de usuario' bind:value={roles} tipo='select' 
            datos={rolesbd} 
            class='mb-3' {disabled} on:change={()=> {
                    const resultado = rolesbd_permisos.find( perm => perm.id === roles );
                    mispermisos=mergeDeep($permisos_struct, resultado.permiso )
                }
            }/>
            {#if roles=='0'}
                <Permisos bind:permisos={mispermisos} acciones={false}/>
            {/if}

            <br/>
        </div>
    </div>
    <!-- <div class="row">
        <div class="col-12 col-md-6">
            {#if insertando===false && $miPermiso.usuarios.delete===true}
                <br/>
                <hr>
                
                <Modal textButton='Eliminar usuario' classButton='btn-danger btn-sm' iconButton='bi-trash' functionSi={function_delete} title='ADVERTENCIA' {disabled}>
                    Esta seguro que desea <strong>Eliminar</strong> el usuario?<br/>
                    Se perderán todos los datos del usuario
                </Modal>
            {/if}
            <br/><br/>   
        </div>
    </div> -->

    <Helper bind:text={helper}></Helper>
</AnimationContainer>

{/if}